export enum SAN_HEADER {
  CLOSE = "search_close",
  OPEN = "search_open",
  X = "search_x",
  CANCEL = "search_cancel",
}

export enum TRACKING_EVENT {
  SUBMIT = "tracking.bct.submitEvent",
  ON_NEXT_PI = "tracking.bct.trackOnNextPageImpression",
  CREATE_EVENT_CONTEXT = "tracking.bct.createEventContext",
  ADD_TO_EVENT = "tracking.bct.addToEvent",
}

export enum SanSearchHistory {
  EXISTS = "exists",
  FILTER = "filter",
}
